var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-warp"},[_c('TopHeader'),_c('keep-alive',{attrs:{"include":_vm.keepAliveRoutes.join(',')}},[_c('router-view',{class:[this.$util.isMobile()?'router-view-warp-mobile':'router-view-warp']})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }